<template lang="pug">
  div.wrap-module-tutorial-welcome.f.fh
    div
      div.warp-logo.mb40
        img(v-if="env && env.indexOf('asc') > -1" src="/img/asc-online-logo.svg").object-fit-cover
        img(v-if="env && env.indexOf('zauna') > -1" src="/img/zauna-logo.svg").object-fit-cover
      span(v-if="env && env.indexOf('asc') > -1").block.mb2.bold ようこそ、ASCオンラインへ
      span(v-if="env && env.indexOf('zauna') > -1").block.mb2.bold ようこそ、zaunaオンラインへ
      span.block.bold 最高の健康習慣を作り上げていきましょう！
</template>

<style lang="scss" scoped>
.wrap-module-tutorial-welcome {
  width: 100%;
  min-height: 100vh;
  .warp-logo {
    margin: 0 auto;
    width: 260px;
  }
}
</style>

<script>
import { env } from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(["uid"]),
    env: function () {
      return env
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
